module.exports = __webpack_public_path__ + "img/head1.30600237.png";